export const defaultOptions = {
  staffOrientation: 'vertical',
  lineSpacing: 1,
  notesNameVisible: false,
  showCurrentNoteName: false,
  noteLengthVisible: false,
  showMeasureProgress: false,
  selectedStaffLine: -1,
  // tutor detection delay:
  tutorDetectionDelay: 300,
  // RMS level
  rmsReference: 0.1,
  fftSize: 2048,
  // this is the "bar" for how close a correlation needs to be
  correlationOutValue: 0.9,
  // mike configuration:
  echoCancellation: true,
  autoGainControl: true,
  noiseSuppression: true,
  highpassFilter: true,
  debug: false
};

function getLocalStorageNumberItem(itemName, defaultValue) {
  let value = localStorage.getItem(itemName);
  if (value === null) value = defaultValue;
  else value = Number(value);
  return value;
}

export const getOptions = function() {
  // BES options:
  const staffOrientation = localStorage.getItem('staffOrientation') || defaultOptions.staffOrientation;

  const lineSpacing = getLocalStorageNumberItem('lineSpacing', defaultOptions.lineSpacing);

  let notesNameVisible = localStorage.getItem('notesNameVisible') || defaultOptions.notesNameVisible;
  if (typeof notesNameVisible === 'string') {
    notesNameVisible = notesNameVisible === 'true';
  }
  let showCurrentNoteName = localStorage.getItem('showCurrentNoteName') || defaultOptions.showCurrentNoteName;
  if (typeof showCurrentNoteName === 'string') {
    showCurrentNoteName = showCurrentNoteName === 'true';
  }
  let noteLengthVisible = localStorage.getItem('noteLengthVisible') || defaultOptions.noteLengthVisible;
  if (typeof noteLengthVisible === 'string') {
    noteLengthVisible = noteLengthVisible === 'true';
  }
  let showMeasureProgress = localStorage.getItem('showMeasureProgress') || defaultOptions.showMeasureProgress;
  if (typeof showMeasureProgress === 'string') {
    showMeasureProgress = showMeasureProgress === 'true';
  }
  const selectedStaffLine = getLocalStorageNumberItem('selectedStaffLine', defaultOptions.selectedStaffLine);

  // TUTOR/mic options:
  const tutorDetectionDelay = getLocalStorageNumberItem('tutorDetectionDelay', defaultOptions.tutorDetectionDelay);

  // MICROPHONE / PITCH DETECTION:
  const rmsReference = getLocalStorageNumberItem('rmsReference',defaultOptions.rmsReference);
  const fftSize = getLocalStorageNumberItem('fftSize', defaultOptions.fftSize);
  const correlationOutValue = getLocalStorageNumberItem('correlationOutValue', defaultOptions.correlationOutValue);

  let echoCancellation = localStorage.getItem('echoCancellation') || defaultOptions.echoCancellation;
  if (typeof echoCancellation === 'string') {
    echoCancellation = echoCancellation === 'true';
  }
  let autoGainControl = localStorage.getItem('autoGainControl') || defaultOptions.autoGainControl;
  if (typeof autoGainControl === 'string') {
    autoGainControl = autoGainControl === 'true';
  }
  let noiseSuppression = localStorage.getItem('noiseSuppression') || defaultOptions.noiseSuppression;
  if (typeof noiseSuppression === 'string') {
    noiseSuppression = noiseSuppression === 'true';
  }
  let highpassFilter = localStorage.getItem('highpassFilter') || defaultOptions.highpassFilter;
  if (typeof highpassFilter === 'string') {
    highpassFilter = highpassFilter === 'true';
  }
  let debug = localStorage.getItem('debug') || defaultOptions.debug;
  if (typeof debug === 'string') {
    debug = debug === 'true';
  }

  return {
    staffOrientation,
    lineSpacing,
    notesNameVisible,
    showCurrentNoteName,
    noteLengthVisible,
    showMeasureProgress,
    selectedStaffLine,
    tutorDetectionDelay,
    rmsReference,
    fftSize,
    correlationOutValue,
    echoCancellation,
    autoGainControl,
    noiseSuppression,
    highpassFilter,
    debug
  };
};
